import React from "react";

import {
  RideGlInformationSolid,
  RideInformativePopover,
  RideSkeleton,
} from "@rimac-seguros/ride-system-components";

import { SliderRange } from "@/components/molecules/SliderRange";

export const ReturnPercentage = ({
  list,
  defaultValue,
  disabled,
  loading,
  onSelected,
  isGreatterValue
}) => {
  return (
    <div className="relative border-b py-ride-gl-spacing-4xlarge border-ride-sys-color-border-default">
      <h2 className="flex items-center gap-ride-gl-spacing-large ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
        ¿Qué % te gustaría recibir?
        <RideInformativePopover
          glyph={<RideGlInformationSolid />}
          aria-label="Porcentaje de devolución"
          isNonModal
          size="medium"
          paragraph="Para obtener hasta un 200% de devolución, debes elegir un monto de  cobertura mayor."
        />
      </h2>
      <div>
        {!loading ? (
          <SliderRange
            list={list}
            defaultValue={defaultValue}
            onSelect={onSelected}
            isGreatterValue={isGreatterValue}
            disabled={disabled}
          />
        ) : (
          <RideSkeleton type="rectangle" height={48} width="100%" />
        )}
      </div>
    </div>
  );
};
